/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react'
import { AreaDeAtuacao } from '../../model/Entidade'
import { Container, Tag } from './style'

export default function InputAreaDeAtuacao(
    props: {
        list: AreaDeAtuacao[],
        onChange: any,
        id: string,
        placeholder: string
    }
) {
    const {
        list, onChange, id, placeholder
    } = props

    const input = useRef<HTMLInputElement>(null)

    function add(item: string): AreaDeAtuacao[] {
        return [...list, { nome: item }]
    }

    const handleChange = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            if (e.currentTarget.value && !hasItem(e.currentTarget.value)) {
                onChange(add(e.currentTarget.value))
                e.currentTarget.value = ''
            }
            e.preventDefault()
        }
    }

    function hasItem(item: string): boolean {
        return list.some((l) => {return l.nome === item})
    }

    const handleAdd = () => {
        if (input.current?.value) {
            onChange(add(input.current.value))
            input.current.value = ''
        }
    }

    function handleRemove(nome: string) {
        const newList = list.filter((l) => {
            return l.nome !== nome
        })
        onChange(newList)
    }

    return (
        <Container>
            <div className="input-group">
                <input
                    type="text"
                    ref={input}
                    id={id}
                    placeholder={placeholder}
                    onKeyDown={handleChange}
                    autoComplete="off"
                />
                <div className="input-group-append">
                    <span
                        className="input-group-text"
                        onClick={handleAdd}
                    >
                        <i className="fas fa-plus fa-sm" />
                    </span>
                </div>
            </div>
            {
                list.map((l) => {
                    return (
                        <Tag key={l.nome}>
                            {l.nome}
                            <i
                                className="far fa-times-circle ml-1"
                                onClick={() => {handleRemove(l.nome)}}
                            />
                        </Tag>
                    )
                })
            }
        </Container>
    )
}
